import { Link, useNavigate } from 'react-router';
import { localDate, plansForDay } from '@/plan/repo';
import { getWorkout } from '@/workouts/repo';
import { workoutStats } from '@/workouts/stats';
import { launchRide } from '@/ride/launch';
import { useSettings } from '@/store/settings';
import { useRide } from '@/store/ride';
import { fmtDuration, useT } from '@/ui/i18n';
import { useAsync } from '@/ui/useAsync';
import { WorkoutGraph } from './WorkoutGraph';
import { defaultCourse } from '@/routes/library';

/** Home page: today's planned workout with a one-click start (SPEC §7.4). */
export function TodayCard() {
  const t = useT();
  const nav = useNavigate();
  const ftp = useSettings((s) => s.settings.ftp);
  const { data } = useAsync(async () => {
    const plans = (await plansForDay(localDate())).filter((p) => p.status === 'planned');
    const items = [];
    for (const p of plans) {
      const w = await getWorkout(p.workoutId);
      if (w) items.push({ plan: p, workout: w });
    }
    return items;
  }, []);

  return (
    <section className="card" data-testid="today-card" aria-labelledby="today-title">
      <div className="panel-head">
        <h2 id="today-title">{t('home.today')}</h2>
        <Link to="/kalender">{t('home.plan')}</Link>
      </div>
      {!data || data.length === 0 ? (
        <div className="grid" style={{ gap: 12 }}>
          <p className="empty-line" style={{ margin: 0 }}>
            {t('home.noToday')}
          </p>
          <div className="row">
            <Link className="btn" to="/fahren?workout=tpl-ramp-test">
              {t('settings.rampTest')}
            </Link>
            <Link className="btn ghost" to="/workouts">
              {t('home.workout')}
            </Link>
          </div>
        </div>
      ) : (
        data.map(({ plan, workout }) => (
          <div key={plan.id} className="grid" style={{ gap: 12 }}>
            <div className="spread">
              <strong style={{ fontSize: 18, fontWeight: 600 }}>{workout.name}</strong>
              <span className="dim num">{fmtDuration(workoutStats(workout.steps, ftp).durationSec)}</span>
            </div>
            <WorkoutGraph steps={workout.steps} ftp={ftp} height={96} />
            <button
              className="primary big"
              onClick={async () => {
                const course = await defaultCourse();
                useRide.getState().setStage('3d');
                launchRide({ workout, plannedId: plan.id, mode: 'erg', course });
                nav('/fahren/live');
              }}
              data-testid="today-start"
            >
              {t('home.startToday')}
            </button>
          </div>
        ))
      )}
    </section>
  );
}
